"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _close_icon = require("./close_icon");
var _tooltip_icon = require("./tooltip_icon");
var _PaymentDetailModal = require("./PaymentDetailModal.proptypes");
var _constant = require("../constant");
var _Popover = _interopRequireDefault(require("../Popover"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable eqeqeq */
// eslint-disable-next-line react/prop-types

var ModalOverlay = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__ModalOverlay",
  componentId: "sc-1wv3oh8-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;align-items:flex-end;justify-content:center;z-index:1000;"]);
var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__ModalContent",
  componentId: "sc-1wv3oh8-1"
})(["background:white;padding:20px;border-radius:8px 8px 0 0;width:100%;max-width:400px;position:relative;box-shadow:0 2px 10px rgba(0,0,0,0.1);margin:0 auto;"]);
var Heading = _styledComponents.default.h2.withConfig({
  displayName: "PaymentDetailModal__Heading",
  componentId: "sc-1wv3oh8-2"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight.XLarge;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral;
});
var Header = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Header",
  componentId: "sc-1wv3oh8-3"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;margin-top:", ";padding:4px;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.xxmicro;
});
var CloseButton = _styledComponents.default.button.withConfig({
  displayName: "PaymentDetailModal__CloseButton",
  componentId: "sc-1wv3oh8-4"
})(["background:none;border:none;cursor:pointer;"]);
var DetailRow = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__DetailRow",
  componentId: "sc-1wv3oh8-5"
})(["display:flex;justify-content:space-between;font-size:", ";margin-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.micro;
});
var TotalRow = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__TotalRow",
  componentId: "sc-1wv3oh8-6"
})(["display:flex;justify-content:space-between;align-items:center;width:97.5%;height:auto;padding:16px 24px 36px 24px;gap:10px;background-color:#ffffff;box-shadow:0px -4px 4px rgba(0,0,0,0.08);border-top:1px solid rgba(0,0,0,0.1);margin-left:-19px;margin-bottom:-20px;margin-top:25px;"]);
var Text = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Text",
  componentId: "sc-1wv3oh8-7"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.normal;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.lineHeight.XLarge;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeight.normal;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.neutral;
});
var Content = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Content",
  componentId: "sc-1wv3oh8-8"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";width:", ";display:flex;flex-direction:row;", ""], function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontFamily.default;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.small;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.small;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontWeight.normal;
}, function (_ref18) {
  var theme = _ref18.theme,
    color = _ref18.color;
  return color ? theme.colors[color] : theme.colors.neutral;
}, function (_ref19) {
  var width = _ref19.width;
  return width;
}, function (_ref20) {
  var isFlex = _ref20.isFlex;
  return isFlex && 'white-space: nowrap;';
});
var Divider = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Divider",
  componentId: "sc-1wv3oh8-9"
})(["width:100%;height:1px;background-color:", ";margin:", " 0;"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.greyLight;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.micro;
});
var HeaderDivider = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__HeaderDivider",
  componentId: "sc-1wv3oh8-10"
})(["position:absolute;width:100%;height:1px;left:0;background-color:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.greyLight;
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Container",
  componentId: "sc-1wv3oh8-11"
})(["width:100%;height:auto;display:flex;flex-direction:column;gap:12px;padding:16px,16px,16px,16px;margin-top:20px;"]);
var Currency = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Currency",
  componentId: "sc-1wv3oh8-12"
})(["margin-right:0.3em;font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";margin-top:8px;"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontFamily.default;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontSize.small;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.lineHeight.XLarge;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.fontWeight.medium;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.neutral;
});
var Price = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__Price",
  componentId: "sc-1wv3oh8-13"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontFamily.default;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSize.titleNormal;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.lineHeight.titleSmall;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.fontWeight.medium;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.neutral;
});
var TotalPrice = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__TotalPrice",
  componentId: "sc-1wv3oh8-14"
})(["display:flex;align-items:center;justify-content:flex-start;"]);
var PopoverContent = _styledComponents.default.span.withConfig({
  displayName: "PaymentDetailModal__PopoverContent",
  componentId: "sc-1wv3oh8-15"
})(["white-space:normal;word-wrap:break-word;overflow:hidden;align-items:center;justify-content:center;font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.fontFamily.default;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.fontSize.small;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.fontWeight.normal;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.colors.greyDark;
});
var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "PaymentDetailModal__ToolTipContent",
  componentId: "sc-1wv3oh8-16"
})(["margin-left:6px;margin-top:-2px;"]);
var PaymentDetailsModal = function PaymentDetailsModal(_ref39) {
  var isOpen = _ref39.isOpen,
    onClose = _ref39.onClose,
    data = _ref39.data,
    theme = _ref39.theme;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var snapSummaryLabel = data.snapSummaryLabel,
    snapPrice = data.snapPrice,
    taxlabel = data.taxlabel,
    taxPrice = data.taxPrice,
    addOnLabel = data.addOnLabel,
    baggagePrice = data.baggagePrice,
    total = data.total,
    heading = data.heading,
    totalLabel = data.totalLabel,
    currency = data.currency,
    bundleSavingsLabel = data.bundleSavingsLabel,
    bundleSavingsPrice = data.bundleSavingsPrice,
    toolTipText = data.toolTipText;
  if (!isOpen) return null;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ModalOverlay, null, /*#__PURE__*/_react.default.createElement(ModalContent, null, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(Heading, null, heading), /*#__PURE__*/_react.default.createElement(CloseButton, {
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_close_icon.CloseIcon, null))), /*#__PURE__*/_react.default.createElement(HeaderDivider, null), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Content, {
      width: "55%"
    }, snapSummaryLabel), /*#__PURE__*/_react.default.createElement(Content, null, snapPrice)), (taxlabel || taxPrice) && /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Content, {
      width: "50%",
      isFlex: true
    }, taxlabel, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      accessible: true,
      asToolTip: true,
      theme: theme,
      trigger: "click",
      content: /*#__PURE__*/_react.default.createElement(PopoverContent, null, toolTipText),
      width: "100%",
      position: _constant.TOP,
      popTop: _constant.POP_TOP
    }, /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(_tooltip_icon.ToolTipIcon, null)))), /*#__PURE__*/_react.default.createElement(Content, null, taxPrice)), (addOnLabel || baggagePrice) && /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Content, {
      width: "50%"
    }, addOnLabel), /*#__PURE__*/_react.default.createElement(Content, null, baggagePrice)), bundleSavingsLabel && bundleSavingsPrice && /*#__PURE__*/_react.default.createElement(Divider, null), bundleSavingsPrice && /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Content, {
      width: "50%",
      color: _constant.COLOR
    }, bundleSavingsLabel), /*#__PURE__*/_react.default.createElement(Content, {
      color: _constant.COLOR
    }, "- ".concat(currency, " ").concat(bundleSavingsPrice)))), /*#__PURE__*/_react.default.createElement(TotalRow, null, /*#__PURE__*/_react.default.createElement(Text, null, totalLabel), /*#__PURE__*/_react.default.createElement(TotalPrice, null, /*#__PURE__*/_react.default.createElement(Currency, null, currency), /*#__PURE__*/_react.default.createElement(Price, null, total)))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PaymentDetailsModal.propTypes = _PaymentDetailModal.PaymentDetailsModalPropTypes;
PaymentDetailsModal.defaultProps = _PaymentDetailModal.PaymentDetailsModalDefaultPropTypes;
var _default = PaymentDetailsModal;
exports.default = _default;